<template>
  <div
    v-loading="loading"
    class="column flex mt-4 registration-padding"
    element-loading-text="Carregando eventos..."
    :class="{ mobile: $vuetify.breakpoint.smAndDown }"
    style="max-width: 900px"
  >
    <div
      v-for="(name, id) in statusNames"
      v-if="groupedEvents[id]"
      :key="id"
      class="column flex relative"
    >
      <div class="tournament-grey--text subheading my-3">
        {{ name }}
      </div>
      <EventCard
        v-for="event in groupedEvents[id]"
        :key="event._id"
        :event="event"
        class="mb-3"
        @click.native="selectEvent(event)"
      />
    </div>

    <div
      v-if="(!loading && !events) || !events.length"
      class="row justify-center my-5 tournament-grey--text"
    >
      Nenhum evento foi encontrado
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

import Event from "@/services/Event";
import EventCard from "@/components/Events/Cards/Event";
import EventStatus from "@/helpers/EventStatus";
import ParseHTTPError from "@/helpers/ParseHTTPError";

import getCurrentSeason from "@/helpers/events/getCurrentSeason";

export default {
  name: "Event",

  components: {
    EventCard,
  },

  props: {
    // Filter only events with this kind
    kind: {
      type: String,
      default: "unreleased",
    },
  },
  data() {
    return {
      loading: false,
      events: [],

      statusNames: {
        released: "Inscrições Liberadas",
        unreleased: "Inscrições não Liberadas",
        ended: "Inscrições encerradas",
      },
    };
  },

  computed: {
    ...mapState(["isJudge", "community"]),

    groupedEvents() {
      return _.groupBy(this.events, (event) => EventStatus(event).name);
    },
  },

  created() {
    this.fetchEvents();
  },

  methods: {
    selectEvent(event) {
      if (!event || EventStatus(event).name != "released")
        return;

      this.$emit("selectedEvent", event);
    },

    fetchEvents() {
      this.loading = true;

      Event.list({
        "event.kind": this.kind,
        "event.season": getCurrentSeason(this.community)._id,
      }).then(
        (res) => {
          this.loading = false;
          this.events = res.data;
        },
        (err) => {
          this.loading = false;

          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: this.$t("general.error"),
            message: error,
          });
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration/Steps/Event.vue